export const MoveIcon = `
<?xml version="1.0" encoding="iso-8859-1"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve" width="512px" height="512px">
<g>
  <g>
    <path d="M129.366,50.088L0,179.454l60.635,60.636l5.882-5.542c0.124-0.117,9.101-8.582,20.466-19.657v243.574h83.212V214.046    l28.068,26.002l60.463-60.601L129.366,50.088z M197.808,216.929l-44.263-41.004v265.889h-49.911V174.886l-14.212,14.212    c-10.905,10.905-21.951,21.543-28.466,27.764l-37.409-37.408L129.366,73.636l105.825,105.825L197.808,216.929z" fill="#878787"/>
  </g>
</g>
<g>
  <g>
    <path d="M451.366,271.912l-5.882,5.542c-0.125,0.117-9.102,8.582-20.467,19.657V53.537h-83.212v244.418l-28.067-26.002    l-60.463,60.599l129.36,129.359l129.367-129.366L451.366,271.912z M276.808,332.54l37.383-37.467l44.263,41.004V70.188h49.911    v266.927l14.213-14.213c10.905-10.905,21.952-21.544,28.466-27.764l37.409,37.409L382.634,438.365L276.808,332.54z" fill="#878787"/>
  </g>
</g>
</svg>
`;
export default MoveIcon;



// WEBPACK FOOTER //
// ./src/scenes/NewCase/Icons/MoveIcon.js